module.exports = __webpack_public_path__ + "0e2eb804ac6f18a5ad72d4971e9be7c0.svg";